import { useEffect, useState } from "react";

const SeriesImagesList = ({
  currentSelectedPump,
  group,
  onImageLoaded,
  isLoadingGraphs = false,
  hasNewGraphsData = false,
}) => {
  const [hqLoaded, setHqLoaded] = useState(false);
  const [powerLoaded, setPowerLoaded] = useState(false);
  const [schemeLoaded, setSchemeLoaded] = useState(false);
  const [hqError, setHqError] = useState(false);
  const [powerError, setPowerError] = useState(false);
  const [schemeError, setSchemeError] = useState(false);

  const hqImageSrc = currentSelectedPump?.data?.files?.["HQc.png"];
  const powerImageSrc = currentSelectedPump?.data?.files?.["Powerc.png"];
  const schemeImageSrc = currentSelectedPump?.data?.files?.["Image.jpg"];

  const deltaData = currentSelectedPump?.data?.delta;
  const inOrange = deltaData?.in_orange; // Проверка, нужно ли выводить дельта параметры

  const optionsOutputData = currentSelectedPump?.data?.optionsOutputData;
  console.log(optionsOutputData)
  const Q = Number(
    optionsOutputData?.find((item) => item?.name === "Q")?.value
  )?.toFixed(2);
  const yscale = Number(
    optionsOutputData?.find((item) => item?.name === "yscale")?.value
  )?.toFixed(2);
  const Loading = deltaData?.loading;
  const H = Number(
    optionsOutputData?.find((item) => item?.name === "p")?.value
  )?.toFixed(2);
  const KPD = Number(
    optionsOutputData?.find((item) => item?.name === "eff")?.value
  )?.toFixed(2);
  const NPSH = Number(
    optionsOutputData?.find((item) => item?.name === "NPSH")?.value
  )?.toFixed(2);
  const P = Number(
    optionsOutputData?.find((item) => item?.name === "P2" || item?.name === "P1")?.value
  )?.toFixed(2);
  const deltaP = optionsOutputData?.find((item) => item?.name === "P2" || item?.name === "P1")?.name
  const openImage = (url) => {
    if (!url) return;

    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Сбрасываем состояние при изменении насоса
  useEffect(() => {
    setHqLoaded(false);
    setPowerLoaded(false);
    setSchemeLoaded(false);
    setHqError(false);
    setPowerError(false);
    setSchemeError(false);

    // Если графики отсутствуют, сразу отмечаем как загруженные
    if (!hqImageSrc) {
      setHqLoaded(true);
      onImageLoaded("hqc");
    } else {
      // Предзагружаем HQ график
      const hqImg = new Image();
      hqImg.onload = () => {
        setHqLoaded(true);
        onImageLoaded("hqc");
      };
      hqImg.onerror = () => {
        setHqError(true);
        onImageLoaded("hqc");
      };
      hqImg.src = hqImageSrc;
    }

    if (!powerImageSrc) {
      setPowerLoaded(true);
      onImageLoaded("powerc");
    } else {
      // Предзагружаем Power график
      const powerImg = new Image();
      powerImg.onload = () => {
        setPowerLoaded(true);
        onImageLoaded("powerc");
      };
      powerImg.onerror = () => {
        setPowerError(true);
        onImageLoaded("powerc");
      };
      powerImg.src = powerImageSrc;
    }

    if (!schemeImageSrc) {
      setSchemeLoaded(true);
      onImageLoaded("photo");
    } else {
      // Предзагружаем схему
      const schemeImg = new Image();
      schemeImg.onload = () => {
        setSchemeLoaded(true);
        onImageLoaded("photo");
      };
      schemeImg.onerror = () => {
        setSchemeError(true);
        onImageLoaded("photo");
      };
      schemeImg.src = schemeImageSrc;
    }
  }, [
    currentSelectedPump,
    hqImageSrc,
    powerImageSrc,
    schemeImageSrc,
    onImageLoaded,
  ]);

  // Отслеживаем изменения hasNewGraphsData для принудительного обновления
  useEffect(() => {
    if (hasNewGraphsData) {
      // Принудительно сбрасываем состояния загрузки при получении новых данных
      setHqLoaded(false);
      setPowerLoaded(false);
      setHqError(false);
      setPowerError(false);

      // Перезагружаем изображения если они есть
      if (hqImageSrc) {
        const hqImg = new Image();
        hqImg.onload = () => {
          setHqLoaded(true);
          onImageLoaded("hqc");
        };
        hqImg.onerror = () => {
          setHqError(true);
          onImageLoaded("hqc");
        };
        hqImg.src = hqImageSrc;
      } else {
        setHqLoaded(true);
        onImageLoaded("hqc");
      }

      if (powerImageSrc) {
        const powerImg = new Image();
        powerImg.onload = () => {
          setPowerLoaded(true);
          onImageLoaded("powerc");
        };
        powerImg.onerror = () => {
          setPowerError(true);
          onImageLoaded("powerc");
        };
        powerImg.src = powerImageSrc;
      } else {
        setPowerLoaded(true);
        onImageLoaded("powerc");
      }
    }
  }, [hasNewGraphsData, hqImageSrc, powerImageSrc, onImageLoaded]);

  // Определяем состояния для отображения
  const hqNeedsLoading = hqImageSrc && !hqLoaded;
  const powerNeedsLoading = powerImageSrc && !powerLoaded;
  const isGraphsLoading =
    hasNewGraphsData && (hqNeedsLoading || powerNeedsLoading);
  const bothGraphsMissing = !hqImageSrc && !powerImageSrc;

  return (
    <div
      className={`images-container ${
        group === "Характеристики" && hqImageSrc && powerImageSrc
          ? "scroll-y"
          : ""
      }`}
    >
      {group === "Характеристики" && (
        <div className="flex-column w-100">
          {/* Общие сообщения для графиков */}
          {bothGraphsMissing && !isLoadingGraphs && (
            <div className="loading-text">Не удалось загрузить графики</div>
          )}
          {isGraphsLoading && (
            <div className="loading-text">Загрузка графиков...</div>
          )}

          {/* Показываем контент всегда, кроме случая когда загружаем новые графики */}
          {!isGraphsLoading && (
            <>
              {/* HQ график */}
              {hqImageSrc && hqLoaded && !hqError && (
                <img alt="HQ" src={hqImageSrc} />
              )}

              {/* Блок с дельта-параметрами - всегда отображаем */}
              <div className="delta-params_container">
                {inOrange !== false && (
                  <div className={"delta-params"}>
                    {Q && Number(Q) > 0 && (
                      <span className="delta-q">
                        Q = {Q}{" "}
                        {currentSelectedPump?.formData?.units === "m"
                          ? "м³/ч"
                          : "л/с"}
                      </span>
                    )}

                    {Loading && yscale && Number(yscale) !== 0 && (
                      <span className="delta-n">n = {Loading}</span>
                    )}

                    {KPD && Number(KPD) > 0 && (
                      <span className="delta-kpd">КПД насоса = {KPD}%</span>
                    )}

                    {H && Number(H) > 0 && (
                      <span className="delta-h">H = {H} м</span>
                    )}

                    {P && Number(P) > 0 && (
                      <span className="delta-p">
                        {deltaP} = {P} кВт
                      </span>
                    )}

                    {NPSH && Number(NPSH) > 0 && (
                      <span className="delta-npsh">NPSH = {NPSH} м</span>
                    )}
                  </div>
                )}
              </div>

              {/* Power график */}
              {powerImageSrc && powerLoaded && !powerError && (
                <img alt="Power" src={powerImageSrc} />
              )}
            </>
          )}
        </div>
      )}

      {group === "Размеры" && (
        <div className="flex-column w-100">
          {/* Чертеж */}
          {schemeImageSrc && schemeLoaded && !schemeError && (
            <img
              alt="Scheme"
              src={schemeImageSrc}
              className="pointer"
              onClick={() => openImage(schemeImageSrc)}
            />
          )}
          {(!schemeImageSrc || schemeError) && (
            <div className="loading-text">Не удалось загрузить чертеж</div>
          )}
          {schemeImageSrc && !schemeLoaded && !schemeError && (
            <div className="loading-text">Загрузка чертежа...</div>
          )}
        </div>
      )}
    </div>
  );
};

export default SeriesImagesList;
